var path = 'areas/projects/actions/Octopus.IIS_summary.html';
var html = "<p> Deploy to IIS using package <strong>{{ properties[\"Octopus.Action.Package.PackageId\"] }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ properties[\"Octopus.Action.Package.FeedId\"] }}</em> <span ng-show=isSingleStep>to machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.IIS_summary.html
// module id = 5409445921492216
// module chunks = 1